import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IMyCompanySite} from "../../../../../../utils/interfaces/my_company/my_company_site/IMyCompanySite";


const useApiCreateMyCompanySite = (): UseMutationResult<IMyCompanySite, CustomAxiosError, any> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {post} = useApiCalls()

    async function doCreate({companyToken, data}: {
        companyToken?: string,
        data: any
    }): Promise<IMyCompanySite> {
        try {
            const response = await post(`/api/company/${companyToken}/my_company/my_company_site/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<IMyCompanySite, CustomAxiosError, any>(
        {
            mutationFn: (
                data
            ) => {
                return doCreate({
                    companyToken: selectedCompany?.company_token,
                    data
                })
            },
            onSuccess: async (obj) => {
                await queryClient.invalidateQueries({queryKey: ["useApiGetMyCompanySites"]});
            },
        }
    );
};


export default useApiCreateMyCompanySite;